<template>
  <v-container fluid>
    <!-- SNACKBAR MENSAJES -->
    <v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>


    <div class="my-2">
      <v-btn @click="dialog = true">check data</v-btn>
    </div>


<v-dialog
  v-model="dialog">
      <v-card>
        <v-card-title>COMPRA
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialog = false">CLOSE</v-btn>
        </v-card-title>
        
        <v-card-title>COMPRA</v-card-title>
 <v-card-text class="pprint">{{compra}}</v-card-text>

      
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialog = false">CLOSE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- FORMULARIO REGISTRO -->
    <v-card elevation="6" class="mb-6">
      <v-card-title class="grey lighten-3">Registro de Compras</v-card-title>

         <v-col cols="12"  sm="12" md="12"  lg="12" >

                  <v-sheet color="grey lighten-1" class="pa-3 mt-3">
                  <strong>DATOS DEL COMPROBANTE</strong>
                  </v-sheet>

              </v-col>
           


      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>


           <v-col cols="12"  sm="6" md="6"  lg="6" >

                <v-select
  v-model="compra.codigo_tipo_comprobante"
  :items="tipoComprobantes"
  label="Tipo de Comprobante"
  item-text="text"
  item-value="value"
  dense
  outlined
></v-select>
            </v-col>

<v-col cols="12"  sm="6" md="6"  lg="6" >
 <template>
               <v-text-field
                 v-model="dateFormatted"
                 label="Date"
                 hint="DD-MM-YYYY format"
                 persistent-hint
                 prepend-icon="mdi-calendar"      
                 @blur="date = parseDate(dateFormatted)" 
                 :rules="[rules.required]"
               ></v-text-field>
             </template>
             <v-date-picker
               v-model="date"
               no-title
               @input="menu1 = false"
             ></v-date-picker>
             <!-- <p>Date in ISO format: <strong>{{ date }}</strong></p>
    <p>Date in ISO format: <strong>{{dateFormatted}}</strong></p> -->
   			
</v-col>

<v-col cols="12"  sm="6" md="6"  lg="6" >

<v-text-field v-model="compra.numero_timbrado" label="Número de Timbrado" :rules="timbradoRules"></v-text-field>

</v-col>

<!-- AGREGAR FORMATO 001-001-0000X -->
<v-col cols="12"  sm="6" md="6"  lg="6" >
<v-text-field v-model="compra.numero_comprobante" 
label="Número Comprobante" 

:rules="numero_comprobanteRules"
  hint="Ej: 001-002-0000250"
  persistent-hint

>



</v-text-field>


  
</v-col>

 <v-col cols="12"  sm="12" md="12"  lg="12" >

                  <v-sheet color="grey lighten-1" class="pa-3 mt-3">
                  <strong>INFORMACIÓN DE LA OPERACIÓN</strong>
                  </v-sheet>

              </v-col>


            <v-col cols="12" sm="6" md="6" lg="6">
  <v-sheet
    class="pa-3"
    elevation="0"
    outlined
    rounded
  >
    <v-radio-group
      v-model="compra.condicion_compra"
      row
      label="Tipo de Pago"
      
      :rules="[v => !!v || 'Campo requerido']"
    >
      <v-radio label="CONTADO" :value="1"></v-radio>
      <v-radio label="CRÉDITO" :value="2"></v-radio>
    </v-radio-group>
  </v-sheet>
</v-col>


<!-- Dentro de tu <v-row> -->
<v-col cols="12" sm="6" md="6" lg="6">

<v-sheet
    class="pa-3"
    elevation="0"
    outlined
    rounded
  >

  <label class="mr-4 " style="width: 200px;">
      Operación en moneda extranjera
    </label>

  <!-- Contenedor solo para mostrar “NO” y “SI” a los lados  inset alinea a la izquierda-->
  <div class="d-flex align-center">

 
    <span class="mr-3 caption">NO</span>

    <v-switch
    
      v-model="compra.operacion_moneda_extranjera"
      :true-value="'S'"  
      :false-value="'N'"  
      inset           
      color="primary"     
      persistent-hint
      hide-details
    ></v-switch>

    <span class="ml-3 caption">SÍ</span>
  </div>


  </v-sheet>
</v-col>










               <v-col cols="12"  sm="12" md="12"  lg="12" >

                  <v-sheet color="grey lighten-1" class="pa-3 mt-3">
                  <strong>INFORMACIÓN DEL PROVEEDOR/VENDEDOR</strong>
                  </v-sheet>

              </v-col>

                          <v-col cols="12"  sm="6" md="6"  lg="6" >
                          <v-select
                            v-model="compra.codigo_tipo_identificacion"
                            :items="tipoIdentificacion"
                            label="Tipo de Identificador"
                            item-text="text"
                            item-value="value"
                            dense
                            outlined
                            :rules="[rules.required]"
                          ></v-select>
                          </v-col>





                                                      
                              <v-col cols="12" sm="6" md="6" lg="6">
                                <v-text-field
                                  v-model="compra.numero_identificacion"
                                  label="Número (sin dígito verificador)"
                                  :rules="numeroIdentificacionRules"
                                  hint="Ingrese el número SIN el dígito verificador y SIN guion"
                                  persistent-hint
                                  outlined
                                  dense
                                ></v-text-field>
                              </v-col>





              <v-col cols="12"  sm="12" md="12"  lg="12" >

                  <v-sheet color="grey lighten-1" class="pa-3 mt-3">
                  <strong>IMPORTE DE LA OPERACIÓN</strong>
                  </v-sheet>

              </v-col>


              <v-col cols="12"  sm="12" md="12"  lg="12" >

                  <v-sheet color="grey lighten-1" class="pa-3 mt-3">
                  <strong>IMPUTACIÓN A OBLIGACIÓN ASOCIADAS</strong>
                  </v-sheet>

              </v-col>



          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="guardarCompra">Registrar</v-btn>
        <v-btn color="grey" @click="limpiar">Limpiar</v-btn>
      </v-card-actions>
    </v-card>

    

    
  </v-container>
</template>

<script>
import compraService from "@/services/compraService";

export default {
  name: "AbmCompra",
  data() {
    return {
     


          dialog: false,
      valid: true,
      validEditar: true,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),

      
      compra: {
        codigo_tipo_registro: "2",
        codigo_tipo_identificacion: 11,
        fecha_emision:this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
        codigo_tipo_comprobante:109,
        numero_timbrado:12345678,
        numero_comprobante:"001-002-0000250",
        condicion_compra:1,
        operacion_moneda_extranjera:"N",


        numero_identificacion: "",
        // ... agrega el resto de campos
      },
      dialogEditar: false,
      mensaje: {
        snackbar: false,
        text: "",
        color: "",
        timeout: 4000,
        colorBtn: "white",
      },
      tipoIdentificacion: [
  { text: '11 - RUC', value: 11 },
  { text: '12 - CÉDULA DE IDENTIDAD', value: 12 },
  { text: '13 - PASAPORTE', value: 13 },
  { text: '14 - CÉDULA EXTRANJERO', value: 14 },
  { text: '15 - SIN NOMBRE', value: 15 },
  { text: '16 - DIPLOMÁTICO', value: 16 },
  { text: '17 - IDENTIFICACIÓN TRIBUTARIA', value: 17 }
],

       tipoComprobantes: [
      { text: '101 - AUTOFACTURA', value: 101 },
      { text: '102 - BOLETA DE TRANSPORTE PÚBLICO DE PASAJEROS', value: 102 },
      { text: '103 - BOLETA DE VENTA', value: 103 },
      { text: '104 - BOLETA RESIMPLE', value: 104 },
      { text: '105 - BOLETOS DE LOTERÍAS, JUEGOS DE AZAR', value: 105 },
      { text: 'NUEVO - 106 - BOLETO O TICKET DE TRANSPORTE AÉREO', value: 106 },
      { text: '107 - DESPACHO DE IMPORTACIÓN', value: 107 },
      { text: '108 - ENTRADA A ESPECTÁCULOS PÚBLICOS', value: 108 },
      { text: '109 - FACTURA', value: 109 },
      { text: '110 - NOTA DE CRÉDITO', value: 110 },
      { text: '111 - NOTA DE DÉBITO', value: 111 },
      { text: '112 - TICKET MÁQUINA REGISTRADORA', value: 112 },
     
    ],


/**
 * INGRESOS  EGRESOS
 * 
 *  { text: '201 - COMPROBANTE DE EGRESOS POR COMPRAS A CRÉDITO', value: 201 },
      { text: '202 - COMPROBANTE DEL EXTERIOR LEGALIZADO', value: 202 },
      { text: '203 - COMPROBANTE DE INGRESO POR VENTAS A CRÉDITO', value: 203 },
      { text: '204 - COMPROBANTE DE INGRESOS ENTIDADES PÚBLICAS, RELIGIOSAS O DE BENEFICIO PÚBLICO', value: 204 },
      { text: '205 - EXTRACTO DE CUENTA – BILLETAJE ELECTRÓNICO', value: 205 },
      { text: '206 - EXTRACTO DE CUENTA DE IPS', value: 206 },
      { text: '207 - EXTRACTO DE CUENTA TC/TD', value: 207 },
      { text: '208 - LIQUIDACIÓN DE SALARIO', value: 208 },
      { text: '209 - OTROS COMPROBANTES DE EGRESOS', value: 209 },
      { text: '210 - OTROS COMPROBANTES DE INGRESOS', value: 210 },
      { text: '211 - TRANSFERENCIAS O GIROS BANCARIOS/ BOLETA DE DEPÓSITO', value: 211 }
 * 
 * 
 */




      requiredRules: [(v) => !!v || "Campo requerido"],

       rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        timbradoRules: [
  v => !!v || "Campo es requerido",
  v => v.length <= 8 || "Máximo 8 caracteres"
],
        numero_comprobanteRules: [
  v => !!v || "Campo es requerido",
  v => v.length <= 20 || "Máximo 20 caracteres",
  v => /^\d{3}-\d{3}-\d{7}$/.test(v) || "Formato debe ser ###-###-####### (ej: 001-002-0000250)"
],


        textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
            ],

    numeroIdentificacionRules: [
  v => !!v || 'Campo requerido',
  v => /^[A-Za-z0-9]+$/.test(v) || 'No se permiten guiones ni caracteres especiales',
  v => v.length <= 20 || 'Máximo 20 caracteres'
]



    };
  },
  mounted() {
  },
  methods: {
    formatDate (date) {
		        if (!date) return null
		
		        const [year, month, day] = date.split('-')
		        return `${day}-${month}-${year}`
		      },

     parseDate (date) {
		        if (!date) return null
		
		        const [year, month, day] = date.split('-')
		        return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
		      },
    
    async guardarCompra() {
      if (this.$refs.form.validate()) {
        try {
          await compraService.save({ compra: this.compra });
          this.mensajeOk("Compra guardada");
          this.limpiar();
          this.cargarCompras();
        } catch (error) {
          this.mensajeError("Error al guardar");
        }
      }
    },
    limpiar() {
       if (campo === "fecha_emision") {
      const hoy = new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10);
      this.compra[campo] = hoy;
      this.dateFormatted = this.formatDate(hoy);
    } else {
      this.compra[campo] = campo.includes("monto") ? 0 : "";
    }
    },
    mensajeOk(texto) {
      this.mensaje = { snackbar: true, text: texto, color: "success", timeout: 4000, colorBtn: "white" };
    },
    mensajeError(texto) {
      this.mensaje = { snackbar: true, text: texto, color: "error", timeout: 4000, colorBtn: "white" };
    },

    soloNumeros (evt) {
    const code = evt.which || evt.keyCode;
    // 48–57 son códigos ASCII de '0'–'9'
    if (code < 48 || code > 57) {
      evt.preventDefault();   // Bloquea cualquier carácter que no sea número
    }
  }
  },
    watch: {
      date (val) {
        
				this.dateFormatted = this.formatDate(this.date)
		        this.compra.fecha_emision=this.dateFormatted;
		
       
      },
    },
  computed:{
    
	computedDateFormatted () {
        return this.formatDate(this.date)
      },

  },
};
</script>


<style scoped>


.pprint {
  white-space:pre-wrap;
  word-wrap:break-word;
}
</style>
